import axios from '@axios'
import crudActions from '@/store/crudActions'

const endpoint = 'auth/users'
const Actions = crudActions(endpoint)

const user = ({ commit }, id) => new Promise((resolve, reject) => {
  axios.get(`/${endpoint}/${id}/`)
    .then(response => {
      commit('GET', response.data)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
const me = ({ commit }) => new Promise((resolve, reject) => {
  axios.get('/auth/user/me')
    .then(response => {
      commit('GET', response.data.payload)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
const updateForeignUser = (ctx, data) => new Promise((resolve, reject) => {
  axios.put(`/auth/users/${data.id}/update_foreign_user/`, data)
    .then(response => {
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})

export default {
  ...Actions,
  user,
  me,
  updateForeignUser,
}
